<template>
  <div>
    <div class="ts-pl-3 ts-mt-3">
      <ul v-if="resource.attachments">
        <li v-for="(att, index) in resource.attachments" :key="index">
          <button
            class="ts-mr-2 hover:ts-text-red-600"
            @click.prevent="deleteRecord(att)"
          >
            <Icon type="ios-trash-outline" size="18" />
          </button>
          <a href="#" @click.prevent="onClickViewFile(index)">{{
            att.file_name
          }}</a>
        </li>
      </ul>
    </div>
    <iModalWrapper
      v-model="show_file"
      :title="$t('task.viewAttachment')"
      width="50%"
      marginTop="10vh"
    >
      <div class="" style="height: 70vh;">
        <div
          class="ts-bg-gray-800 ts-w-full ts-h-full ts-rounded-md ts-p-4 ts-relative group ts-flex ts-items-center ts-justify-center"
        >
          <button
            @click.prevent="onMoveBack"
            class="previous ts-invisible ts-absolute hover:ts-bg-gray-500 ts-left-0 ts-ml-3 ts-bg-gray-400 ts-px-4 ts-py-2 ts-rounded-md ts-flex ts-items-center ts-justify-items-center"
          >
            <i class="fas fa-chevron-left ts-text-gray-800"></i>
          </button>
          <button
            @click.prevent="onMoveNext"
            class="previous ts-invisible ts-absolute hover:ts-bg-gray-500 ts-right-0 ts-mr-3 ts-bg-gray-400 ts-px-4 ts-py-2 ts-rounded-md ts-flex ts-items-center ts-justify-items-center"
          >
            <i class="fas fa-chevron-right ts-text-gray-800"></i>
          </button>
          <img
            v-if="isImage"
            :src="showContent"
            class="ts-w-full ts-h-full ts-object-contain"
          />
          <div class="ts-w-full ts-h-full" v-else-if="isPdf">
            <iframe
              :src="showContent"
              frameborder="0"
              class="ts-w-full ts-h-full"
            ></iframe>
          </div>
          <div v-else class="ts-text-center">
            <p class="ts-font-semibold ts-text-gray-300">{{ getFileName }}</p>
            <a :href="showContent" :download="getFileName">
              <Icon type="ios-cloud-download" size="100" />
            </a>
          </div>
        </div>
      </div>
    </iModalWrapper>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
export default {
  props: ['resource'],
  components: {
    iModalWrapper
  },
  data() {
    return {
      file_index_view: 0,
      show_file: false
    }
  },
  computed: {
    fileResource() {
      return this.resource.attachments[this.file_index_view]
    },
    showContent() {
      if (!this.resource.attachments) {
        return undefined
      }

      return this.fileResource
        ? this.fileResource.file_storage_path_read
        : undefined
    },
    isImage() {
      if (!this.resource.attachments) {
        return undefined
      }
      let extension = this.fileResource
        ? this.fileResource.file_extension
        : undefined

      return ['png', 'jpg', 'jpeg'].find(e => e === extension)
    },
    isPdf() {
      if (!this.resource.attachments) {
        return undefined
      }
      let extension = this.fileResource
        ? this.fileResource.file_extension
        : undefined

      return ['pdf'].find(e => e === extension)
    },
    getFileName() {
      if (!this.resource.attachments) {
        return undefined
      }
      return this.fileResource ? this.fileResource.file_name : undefined
    }
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['removeAttachments']),
    deleteRecord(record) {
      let id = this.$route.params.id
      this.$confirm({
        title: this.$t('task.are_you_want_to_delete_it_cant_redo'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.removeAttachments({ id, fileName: record.file_name })
            .then(response => {
              this.resource.attachments.splice(
                this.resource.attachments.indexOf(record),
                1
              )
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onClickViewFile(index) {
      this.show_file = true
      this.file_index_view = index
    },
    onMoveNext() {
      this.file_index_view =
        this.file_index_view + 1 <= this.resource.attachments.length - 1
          ? this.file_index_view + 1
          : 0
    },
    onMoveBack() {
      this.file_index_view =
        this.file_index_view - 1 > 0
          ? this.file_index_view - 1
          : this.resource.attachments.length - 1
    }
  }
}
</script>

<style scoped>
.group:hover .previous {
  visibility: visible;
}
iframe {
  width: 100%;
  /* height: 70vh; */
  /* border: 2px solid #acacac; */
}
</style>
